export default "__VITE_ASSET__2e67d4e2__"